import * as images from './page3Images.js'
import pigAnimation from "../../../animations/Maialino.json"
import GriLottie from '../../dsy-inhouse/GriLottiePlayer.jsx'

export default function handlePage3(data) {
    const result = []
    //result.push(<img src={images.pig} style={{}} alt="" role="presentation" />)
    result.push(<GriLottie animationData={pigAnimation} style={{ marginTop: "-2rem"}} />)      //  style={{ width: 300, height: 300 }}
    return result
}